import { useTranslation } from "react-i18next";

import { InputSkeleton } from "#components/atoms/Skeleton/Skeleton";
import { Combobox } from "#components/molecules/Combobox/Combobox";
import { useClients } from "#modules/clients/view/useClients";
import { useCreateClient } from "#modules/clients/view/useCreateClient";

type ClientSelectProps = {
  value: string | null;
  onChange: (value: string | null) => void;
};

const ClientSelect = ({ value, onChange }: ClientSelectProps) => {
  const { t } = useTranslation();
  const { clients, isLoading } = useClients();

  const { createClient, isPending } = useCreateClient({
    options: {
      shouldShowSuccessToast: true,
      onSuccess: (newClient) => {
        onChange(newClient.id);
      },
    },
  });

  const data = clients.map((client) => ({ value: client.id, label: client.name }));

  if (isLoading) {
    return <InputSkeleton label={t("quoteRequestLine.clientName")} />;
  }

  return (
    <Combobox
      label={t("quoteRequestLine.clientName")}
      placeholder={t("quoteRequestsV2.modal.clientPlaceholder")}
      hint={t("quoteRequestsV2.modal.clientHint")}
      data={data}
      disabled={isPending}
      value={value}
      onChange={onChange}
      onCreateOption={(name) => createClient({ name })}
    />
  );
};

export { ClientSelect };
